module.exports = __webpack_public_path__ + "media/flat/maestro-0837dc66.svg";